import { render, staticRenderFns } from "./addressBlock.vue?vue&type=template&id=f3e010bc&scoped=true&"
import script from "./addressBlock.vue?vue&type=script&lang=js&"
export * from "./addressBlock.vue?vue&type=script&lang=js&"
import style0 from "./addressBlock.vue?vue&type=style&index=0&id=f3e010bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e010bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
